import menusConfigs from '../../config/sites/menus'
import axiosVerbose from '../utils/axios/axiosVerbose'
import { logError } from '../utils/errors'

let CACHED_STATS: any = null

export const fetchStats = ({ apiUrlPrefix }: { apiUrlPrefix: string }) => {
  return (dispatch: any, getState: any) => {
    const state = getState()
    if (state.common.stats) {
      return
    }

    if (CACHED_STATS) {
      return dispatch({
        type: 'receiveStats',
        payload: CACHED_STATS
      })
    }

    return axiosVerbose
      .get(`${apiUrlPrefix}/shopfront_api/stat`)
      .then(response => {
        CACHED_STATS = response.data

        return dispatch({
          type: 'receiveStats',
          payload: response.data
        })
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        return dispatch({
          type: 'receiveStatsError',
          error: true
        })
      })
  }
}

export const setCurrentSite = (currentSite: string) => {
  return (dispatch: any, getState: any) => {
    dispatch({
      type: 'loadSiteConfigs',
      payload: {
        currentSite
      }
    })
    return dispatch({
      type: 'setCurrentSite',
      payload: currentSite
    })
  }
}

export const setBaseUrl = (baseUrl: string) => {
  return {
    type: 'setBaseUrl',
    payload: baseUrl
  }
}

export const setMenuConfig = (currentSite: string) => {
  return {
    type: 'setMenuConfig',
    payload: menusConfigs[currentSite] || []
  }
}

export const showAlert = (
  message: string,
  type = 'warning',
  canBeDismissed = true
) => {
  return {
    type: 'showAlert',
    payload: {
      message,
      type,
      canBeDismissed
    }
  }
}

export const hideAlert = (message: string) => {
  return {
    type: 'hideAlert',
    payload: {
      message
    }
  }
}

export const resetAlerts = () => {
  return {
    type: 'resetAlerts'
  }
}

export const setErrorPage = (id: any) => {
  return {
    type: 'setErrorPage',
    payload: {
      id
    }
  }
}

export const resetErrorPage = () => {
  return {
    type: 'resetErrorPage'
  }
}

export const noIndex = () => {
  return {
    type: 'noIndex'
  }
}

export const setClientVersion = ({
  clientVersion
}: {
  clientVersion: number
}) => {
  return {
    type: 'setClientVersion',
    payload: { clientVersion }
  }
}

export const clientFinishedLoading = () => {
  return {
    type: 'clientFinishedLoading'
  }
}

export const setSeoMeta = ({
  title,
  meta_description,
  description
}: {
  title: string
  meta_description?: string
  description: string
}) => {
  return {
    type: 'setSeoMeta',
    payload: {
      title,
      meta_description: meta_description || description
    }
  }
}



// WEBPACK FOOTER //
// ./common/actions/common.ts